// Injects global CSS animation keyframes once into the document head.
// Import this file anywhere — the guard prevents duplicate injection.
if (typeof document !== 'undefined' && !document.getElementById('tm-animations')) {
  const el = document.createElement('style');
  el.id = 'tm-animations';
  el.textContent = [
    '@keyframes spin { to { transform: rotate(360deg); } }',
    '@keyframes tmFadeUp { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }',
  ].join('\n');
  document.head.appendChild(el);
}
